import { CUSTOM_FIELD_TYPE } from "fieldpro-tools";
import _ from "lodash";

import { getListCategories } from "components/Input/InputMatrix/utils/getMatrixCategories";
import {
  getCustomFieldColumns,
  getMatrixFieldsSchema,
  getNameKey,
} from "components/Input/InputMatrix/utils/getQuestionColumns";
import { TABLE_COLUMN_TYPE } from "components/Table/model";
import TLang from "model/application/Lang";
import { IList, IListSchema } from "model/entities/List";
import { IListItem } from "model/entities/ListItem";
import { getMatrixRows } from "utils/formatting/matrixFields";

interface IFormatAttributeValue {
  schema: IListSchema[];
  attribute: IListSchema;
  item: IListItem;
  allLists: IList[];
  lang: TLang;
}

export const formatAttributeValue = ({
  schema,
  item,
  attribute,
  allLists,
  lang,
}: IFormatAttributeValue) => {
  const value = item[attribute.column_tag];

  switch (attribute.type) {
    case CUSTOM_FIELD_TYPE.BOOLEAN: {
      return value ? "TRUE" : "FALSE";
    }

    case CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
      const key = value?.key ?? value;
      const options = _.find(schema, {
        column_tag: attribute.column_tag,
      })?.options;

      const selectedOption = _.find(options, { key });

      return selectedOption ? { label: selectedOption?.label, key } : undefined;
    }

    case CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
      const options = _.find(schema, {
        column_tag: attribute.column_tag,
      })?.options;

      const selectedOptions = _.filter(options, ({ key }) =>
        _.includes(value, key),
      );

      return selectedOptions;
    }

    case CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
      const key = value?.key ?? value;
      const option = item._linked_options?.find((opt) => {
        return opt?.key === key;
      });

      return option ? { label: option?.label, key } : undefined;
    }

    case CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST: {
      const option = item._linked_options?.filter((opt) => {
        return _.includes(value, opt?.key);
      });

      return option;
    }

    case CUSTOM_FIELD_TYPE.MATRIX_ON_LIST: {
      const list = _.find(allLists, { id: attribute.list_id, active: true });
      if (!list) {
        return value;
      }

      const categories = getListCategories(list, attribute);
      const matrixSchema = getMatrixFieldsSchema(attribute);
      const columns = [
        {
          name: "_name",
          label: "Item name",
          type: TABLE_COLUMN_TYPE.TEXT,
        },
        ...getCustomFieldColumns(matrixSchema),
      ];

      const rows = getMatrixRows({
        dynamicObjects: item[attribute.column_tag],
        fieldsSchema: matrixSchema,
        lists: allLists ?? [],
        lang: lang,
      });

      const formattedValue = {
        title: item[getNameKey(attribute)] ?? item._displayed_name,
        categories,
        columns,
        rows,
      };

      return formattedValue;
    }

    default: {
      return value;
    }
  }
};
